/* RESPONSIBLE TEAM: team-reporting */

import { tracked } from 'tracked-built-ins';
import { resource } from 'ember-resources/util/function-resource';
import { getOwner } from '@ember/application';
import type ApplicationInstance from '@ember/application/instance';

export default function QueryParams(host: unknown) {
  let owner = getOwner(host) as ApplicationInstance;
  let router = owner.lookup('service:router');
  let initialValues = router.currentRoute.queryParams;
  return resource(({ on }) => {
    let values = tracked(initialValues);
    let setQueryParams = () => {
      for (let [key, value] of Object.entries<string>(router.currentRoute.queryParams)) {
        if (values[key] !== value) {
          values[key] = value;
        }
      }
    };
    router.on('routeDidChange', setQueryParams);
    on.cleanup(() => {
      router.off('routeDidChange', setQueryParams);
    });
    return values;
  });
}
